import React, { useEffect, useState } from "react";
import ReviewClasses from "./review.module.css";
import { Services } from "Services";
import Skeleton from "./Skeleton";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useSearchParams } from "react-router-dom";
import moment from "moment";
import ReactPaginate from "react-paginate";

function Review() {
    const Navigate = useNavigate();
    const [params] = useSearchParams();
    const [showPaginate, setShowPagiate] = useState(true);
    const [forcepage, setforcepage] = useState(0);
    const RecordCount = 20;
    console.log(params.get("TutorId"));
    const token = { Authorization: `token ${localStorage.getItem("token")}` };
    const [pageCount, setpageCount] = useState(1);
    const [searchparams, setSearchParams] = useSearchParams();

    // Rating filter: null means not sent; otherwise 1-5
    const [ratingFilter, setRatingFilter] = useState(null);
    const [exportLink, setExportLink] = useState(null);

    const [Data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    // track which review rows are expanded (show full text)
    const [expandedIds, setExpandedIds] = useState([]);
    // track which reviews are overflowing (need "Read more")
    const [overflowingIds, setOverflowingIds] = useState(new Set());
    const getData = (skip = 0, rating = null) => {
        setLoading(true);
        const body = {
            TutorID: params.get("TutorId"),
        };
        // include RatingFilter only when provided (not null/undefined)
        if (rating !== null && rating !== undefined) {
            body.RatingFilter = Number(rating);
        }

        Services.getAllTutorReviews("POST", JSON.stringify(body), token, skip)
            .then((response) => {
                console.log(response);
                setTimeout(() => {
                    setLoading(false);
                }, 300);
                if (response.Status === 1) {
                    setData(response.Reviews);
                    // capture any export/download link returned by the API
                    const link = response.link || null;
                    setExportLink(link);
                    if (
                        response.Reviews.length == 0 ||
                        response.Count <= RecordCount
                    ) {
                        setShowPagiate(false);
                    } else {
                        if (!showPaginate) {
                            setShowPagiate(true);
                        }
                        setpageCount(
                            Math.ceil(
                                Number(response?.Count) / Number(RecordCount)
                            )
                        );
                    }
                } else if (response.Status === 0) {
                    toast.error(`${response.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    if (response.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                setLoading(false);
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };
    // re-fetch when page or rating filter in search params changes
    useEffect(() => {
        const skip = searchparams.get("page")
            ? (Number(searchparams.get("page")) - 1) * RecordCount
            : 0;
        const rf = searchparams.get("RatingFilter");
        getData(skip, rf ? Number(rf) : null);
    }, [searchparams.get("page"), searchparams.get("RatingFilter")]);

    const handlePageChange = (selectedObject) => {
        const currentRF = searchparams.get("RatingFilter");
        const nextParams = {
            page: selectedObject.selected + 1,
            TutorId: params.get("TutorId"),
            tab: params.get("tab"),
        };
        if (currentRF) nextParams.RatingFilter = currentRF;
        setSearchParams(nextParams);
        window.scrollTo({ top: 10, behavior: "instant" });
        setforcepage(selectedObject.selected);
        setLoading(true);
    };

    const handleRatingChange = (eOrVal) => {
        // Accept either an event or a numeric value/null
        let val = null;
        if (typeof eOrVal === "number" || eOrVal === null) {
            val = eOrVal;
        } else if (eOrVal && eOrVal.target) {
            val =
                eOrVal.target.value === "" ? null : Number(eOrVal.target.value);
        }
        setRatingFilter(val);
        const nextParams = {
            page: 1,
            TutorId: params.get("TutorId"),
            tab: params.get("tab"),
        };
        if (val !== null) nextParams.RatingFilter = val;
        setSearchParams(nextParams);
        setforcepage(0);
        // fetch immediately using selected value
        getData(0, val);
    };
    return (
        <div className={ReviewClasses["Container"]}>
            {/* <div className={ReviewClasses["over-view"]}>
                <header>
                    <h3>Review</h3>
                    <div className={ReviewClasses["header-left"]}>
                        <div>
                            <h4> No of Ratings</h4>
                            <p>0</p>
                        </div>
                        <div>
                            <h4> Average Ratings</h4>
                            <p>No Reviews</p>
                        </div>
                    </div>
                    <div className={ReviewClasses["header-right"]}>
                        <div>
                            <h4> Reviewd Hours</h4>
                            <p>0.0 Hours</p>
                        </div>
                        <div>
                            <h4> Latest Reviews</h4>
                            <p>No Reviews</p>
                        </div>
                    </div>
                </header>
            </div> */}

            <div>
                <div className={ReviewClasses["rating-filter"]}>
                    <div className={ReviewClasses["filter-label"]}>
                        Filter by Rating
                    </div>
                    <div className={ReviewClasses["filter-chips"]}>
                        <button
                            type="button"
                            className={
                                ratingFilter === null
                                    ? ReviewClasses["chip"] +
                                      " " +
                                      ReviewClasses["active"]
                                    : ReviewClasses["chip"]
                            }
                            onClick={() => handleRatingChange(null)}>
                            All
                        </button>
                        {[1, 2, 3, 4, 5].map((r) => (
                            <button
                                key={r}
                                type="button"
                                className={
                                    ReviewClasses["star-chip"] +
                                    (ratingFilter === r
                                        ? " " + ReviewClasses["active"]
                                        : "")
                                }
                                onClick={() => handleRatingChange(r)}>
                                <span className={ReviewClasses["star"]}>★</span>
                                <span className={ReviewClasses["star-text"]}>
                                    {r}
                                </span>
                            </button>
                        ))}
                    </div>
                    <div style={{ marginLeft: 12 }}>
                        <button
                            type="button"
                            className={ReviewClasses["export-btn"]}
                            onClick={() => {
                                if (exportLink)
                                    window.open(exportLink, "_blank");
                                else alert("No export link available");
                            }}>
                            Export
                        </button>
                    </div>
                </div>
                {loading ? (
                    <Skeleton />
                ) : (
                    <div className={ReviewClasses["review"]}>
                        <table>
                            <thead>
                                <tr>
                                    <th>Batch Name</th>
                                    <th>Student Name</th>
                                    <th>Class Date </th>
                                    <th>Reviewed on</th>
                                    <th>Review</th>
                                    <th>Rating</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Data.length > 0 ? (
                                    Data.map((item, idx) => {
                                        const keyId =
                                            item?.ReviewID ||
                                            item?.ScheduleClassID ||
                                            idx;
                                        const isExpanded = expandedIds.includes(
                                            String(keyId)
                                        );
                                        const isLong = overflowingIds.has(String(keyId));

                                        return (
                                            <tr
                                                key={String(keyId)}
                                                onClick={() => {
                                                    Navigate(
                                                        `/scheduledClasses/Details?scheduleID=${item.ScheduleClassID}`
                                                    );
                                                }}>
                                                <td>{item.BatchName}</td>
                                                <td>{item.StudentName}</td>
                                                <td>
                                                    {item?.Scheduled_StartDate &&
                                                        moment(
                                                            item?.Scheduled_StartDate
                                                        ).format("DD-MM-YYYY")}
                                                </td>
                                                <td>
                                                    {item?.ReviewDateTime &&
                                                        moment(
                                                            item?.ReviewDateTime
                                                        ).format("DD-MM-YYYY")}
                                                </td>

                                                <td
                                                    style={{
                                                        maxWidth: "200px",
                                                        wordWrap: "break-word",
                                                    }}>
                                                    <div
                                                        ref={(el) => {
                                                            if (el && !isExpanded) {
                                                                const isClamped = el.scrollHeight > el.clientHeight;
                                                                if (isClamped && !overflowingIds.has(String(keyId))) {
                                                                    setOverflowingIds(prev => new Set([...prev, String(keyId)]));
                                                                } else if (!isClamped && overflowingIds.has(String(keyId))) {
                                                                    setOverflowingIds(prev => {
                                                                        const newSet = new Set(prev);
                                                                        newSet.delete(String(keyId));
                                                                        return newSet;
                                                                    });
                                                                }
                                                            }
                                                        }}
                                                        className={
                                                            ReviewClasses[
                                                                "reviewText"
                                                            ] +
                                                            (isExpanded
                                                                ? " " +
                                                                  ReviewClasses[
                                                                      "expanded"
                                                                  ]
                                                                : "")
                                                        }>
                                                        {item.Review}
                                                    </div>
                                                    {isLong && (
                                                        <div>
                                                            <button
                                                                className={
                                                                    ReviewClasses[
                                                                        "readMoreBtn"
                                                                    ]
                                                                }
                                                                onClick={(
                                                                    e
                                                                ) => {
                                                                    e.stopPropagation();
                                                                    setExpandedIds(
                                                                        (
                                                                            prev
                                                                        ) => {
                                                                            const s =
                                                                                new Set(
                                                                                    prev
                                                                                );
                                                                            if (
                                                                                s.has(
                                                                                    String(
                                                                                        keyId
                                                                                    )
                                                                                )
                                                                            )
                                                                                s.delete(
                                                                                    String(
                                                                                        keyId
                                                                                    )
                                                                                );
                                                                            else
                                                                                s.add(
                                                                                    String(
                                                                                        keyId
                                                                                    )
                                                                                );
                                                                            return Array.from(
                                                                                s
                                                                            );
                                                                        }
                                                                    );
                                                                }}>
                                                                {isExpanded
                                                                    ? "Show less"
                                                                    : "Read more"}
                                                            </button>
                                                        </div>
                                                    )}
                                                </td>

                                                <td>{item.Rating}</td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td
                                            colSpan={4}
                                            style={{ textAlign: "center" }}>
                                            No Reviews Found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
            {showPaginate && (
                <div
                    style={{
                        justifySelf: "right",
                    }}>
                    <ReactPaginate
                        pageCount={pageCount}
                        // pageRange={2}
                        forcePage={forcepage}
                        marginPagesDisplayed={2}
                        onPageChange={handlePageChange}
                        breakClassName={"page-item"}
                        breakLinkClassName={"page-link"}
                        containerClassName={"pagination"}
                        pageClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                        previousClassName={"page-item"}
                        previousLinkClassName={"page-link"}
                        nextClassName={"page-item"}
                        nextLinkClassName={"page-link"}
                        activeClassName={"active"}
                    />
                </div>
            )}
        </div>
    );
}

export default Review;
